export default {
  name: 'email-notification',
  translationKey: 'email-notification-module',
  routePrefix: 'email-notification',
  routeNamePrefix: 'admin.email-notification',
  directRoutesAvailable: false,
}
